/**
 * Pílula de status.
 *
 * Aparece em quase toda tabela do painel: estado de sincronização, resultado do
 * FCrDNS, situação da zona. Os pares de cor vêm dos tokens semânticos do
 * handoff e não devem ser escolhidos caso a caso — o mesmo significado precisa
 * ter sempre a mesma cor, senão a leitura por varredura deixa de funcionar.
 */

export type TomPill = 'ok' | 'aviso' | 'erro' | 'info' | 'neutro' | 'ipv6';

const TONS: Record<TomPill, string> = {
  ok: 'bg-sucesso-fundo text-sucesso',
  aviso: 'bg-aviso-fundo text-aviso',
  erro: 'bg-erro-fundo text-erro',
  info: 'bg-info-fundo text-info',
  neutro: 'bg-borda-suave text-texto-suave',
  ipv6: 'bg-ipv6-fundo text-ipv6',
};

interface PillProps {
  tom?: TomPill;
  children: React.ReactNode;
  /** Usa fonte mono — para versão de IP, tipo de registro e afins. */
  mono?: boolean;
  className?: string;
}

export function Pill({ tom = 'neutro', children, mono = false, className = '' }: PillProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-pill px-2.5 py-1 text-[11.5px] font-bold ${
        TONS[tom]
      } ${mono ? 'font-mono' : ''} ${className}`}
    >
      {children}
    </span>
  );
}

/**
 * Traduz o estado de sincronização de um bloco ou zona para o tom certo.
 * Centralizado para que a mesma situação não apareça verde numa tela e âmbar
 * em outra.
 */
export function tomDeStatus(status: string): TomPill {
  const s = status.toLowerCase();
  if (['ativa', 'sincronizado', 'ok', 'confirmado', 'publicado'].some((t) => s.includes(t))) {
    return 'ok';
  }
  if (['pendente', 'propagando', 'aguardando', 'divergente', 'atrasado'].some((t) => s.includes(t))) {
    return 'aviso';
  }
  if (['erro', 'falha', 'não delegada', 'nao delegada', 'rejeitad'].some((t) => s.includes(t))) {
    return 'erro';
  }
  return 'neutro';
}
